export const _getCurrentUser = (store) => {
  const { user } = store.getState();
  return user;
};
